import { createFileRoute } from "@tanstack/react-router";
import { Play } from "@/components/Play/Play.tsx";

export const Route = createFileRoute("/_mainLayout/play/")({
  component: Play
});